import create from 'zustand';

export interface AccuracyFilters {
  titleInaccuracies: boolean;
  bulletInaccuracies: boolean;
  descriptionInaccuracies: boolean;
  imageInaccuracies: boolean;
  videoInaccuracies: boolean;
}

interface AccuracyFilterState {
  isOpen: boolean;
  filters: AccuracyFilters;
  tempFilters: AccuracyFilters;
  setFilter: (key: keyof AccuracyFilters, value: boolean) => void;
  setTempFilter: (key: keyof AccuracyFilters, value: boolean) => void;
  setAllFilters: () => void;
  openModal: () => void;
  closeModal: () => void;
  resetFilters: () => void;
  applyFilters: () => void;
  getActiveFilter: () => string[];
}

const defaultFilters: AccuracyFilters = {
  titleInaccuracies: false,
  bulletInaccuracies: false,
  descriptionInaccuracies: false,
  imageInaccuracies: false,
  videoInaccuracies: false
};

const FilterNames = {
  titleInaccuracies: 'title',
  bulletInaccuracies: 'bullet',
  descriptionInaccuracies: 'description',
  imageInaccuracies: 'image',
  videoInaccuracies: 'video'
};

export const useAccuracyFilterStore = create<AccuracyFilterState>((set, get) => ({
  isOpen: false,
  filters: { ...defaultFilters },
  tempFilters: { ...defaultFilters },
  setTempFilter: (key, value) => set((state) => ({ tempFilters: { ...state.tempFilters, [key]: value } })),
  setFilter: (key, value) => {
    set(() => ({ filters: { ...defaultFilters, [key]: value } }));
    set(() => ({ tempFilters: { ...defaultFilters, [key]: value } }));
  },
  openModal: () =>
    set((state) => ({
      isOpen: true,
      tempFilters: { ...state.filters } // Initialize temp filters with current filters
    })),
  closeModal: () => set({ isOpen: false }),
  resetFilters: () =>
    set((state) => ({
      tempFilters: { ...defaultFilters },
      filters: { ...defaultFilters }
    })),
  applyFilters: () =>
    set((state) => ({
      filters: { ...state.tempFilters },
      isOpen: false
    })),
  setAllFilters: () => set({
    filters: {
      titleInaccuracies: true,
      bulletInaccuracies: true,
      descriptionInaccuracies: true,
      imageInaccuracies: true,
      videoInaccuracies: true
    }
  }),
  getActiveFilter: () => {
    const filters = get().filters;
    return Object.entries(filters)
      .filter(([_, isActive]) => isActive)
      .map(([key, _]) => FilterNames[key as keyof AccuracyFilters]);
  }
}));
